import comp from "./GlobalToastWrapper";
export default comp;
